import { Box, Skeleton, HStack, VStack } from '@chakra-ui/react'

/**
 * Skeleton loaders that match actual component shapes.
 * Used for Suspense fallbacks during lazy loading.
 */

export function ChartSkeleton() {
  return (
    <Box p={4}>
      {/* Header */}
      <HStack justify="space-between" mb={4}>
        <Skeleton height="20px" width="200px" />
        <HStack spacing={1}>
          <Skeleton height="24px" width="50px" borderRadius="md" />
          <Skeleton height="24px" width="50px" borderRadius="md" />
          <Skeleton height="24px" width="50px" borderRadius="md" />
        </HStack>
      </HStack>

      {/* Chart area with bars */}
      <HStack align="flex-end" spacing={2} h="180px" px={8}>
        <Skeleton height="60%" width="8%" />
        <Skeleton height="80%" width="8%" />
        <Skeleton height="45%" width="8%" />
        <Skeleton height="90%" width="8%" />
        <Skeleton height="70%" width="8%" />
        <Skeleton height="55%" width="8%" />
        <Skeleton height="85%" width="8%" />
        <Skeleton height="40%" width="8%" />
        <Skeleton height="65%" width="8%" />
        <Skeleton height="75%" width="8%" />
      </HStack>

      {/* Legend */}
      <HStack justify="center" mt={4} spacing={6}>
        <HStack spacing={2}>
          <Skeleton height="12px" width="12px" borderRadius="sm" />
          <Skeleton height="14px" width="60px" />
        </HStack>
        <HStack spacing={2}>
          <Skeleton height="12px" width="12px" borderRadius="sm" />
          <Skeleton height="14px" width="50px" />
        </HStack>
        <HStack spacing={2}>
          <Skeleton height="12px" width="12px" borderRadius="sm" />
          <Skeleton height="14px" width="55px" />
        </HStack>
        <HStack spacing={2}>
          <Skeleton height="12px" width="12px" borderRadius="sm" />
          <Skeleton height="14px" width="45px" />
        </HStack>
      </HStack>
    </Box>
  )
}

export function TableSkeleton() {
  return (
    <Box>
      {/* Header row */}
      <HStack spacing={4} p={3} borderBottomWidth="1px">
        <Skeleton height="16px" width="20px" />
        <Skeleton height="16px" width="70px" />
        <Skeleton height="16px" width="100px" />
        <Skeleton height="16px" width="50px" />
        <Skeleton height="16px" width="120px" />
        <Skeleton height="16px" width="80px" />
        <Skeleton height="16px" width="60px" />
        <Skeleton height="16px" width="60px" />
      </HStack>

      {/* Data rows */}
      {Array.from({ length: 8 }).map((_, i) => (
        <HStack key={i} spacing={4} p={3} borderBottomWidth="1px">
          <Skeleton height="14px" width="20px" />
          <Skeleton height="20px" width="70px" borderRadius="md" />
          <Skeleton height="14px" width="100px" />
          <Skeleton height="14px" width="40px" />
          <Skeleton height="14px" width="110px" />
          <Skeleton height="20px" width="70px" borderRadius="md" />
          <Skeleton height="14px" width="50px" />
          <Skeleton height="14px" width="50px" />
        </HStack>
      ))}
    </Box>
  )
}

export function FilterSkeleton() {
  return (
    <HStack spacing={4}>
      <Skeleton height="32px" width="250px" borderRadius="md" />
      <Skeleton height="32px" width="80px" borderRadius="md" />
      <Skeleton height="32px" width="80px" borderRadius="md" />
    </HStack>
  )
}

export function InsightsSkeleton() {
  return (
    <HStack spacing={6} align="stretch">
      {/* Risk Factors Chart */}
      <Box flex={1} p={4}>
        <Skeleton height="20px" width="150px" mb={4} />
        <VStack align="stretch" spacing={2}>
          {Array.from({ length: 6 }).map((_, i) => (
            <HStack key={i} spacing={3}>
              <Skeleton height="14px" width="120px" />
              <Skeleton height="20px" flex={1} borderRadius="sm" />
            </HStack>
          ))}
        </VStack>
      </Box>

      {/* Analysis Breakdown */}
      <Box flex={1} p={4}>
        <Skeleton height="20px" width="180px" mb={4} />
        <VStack align="stretch" spacing={3}>
          {Array.from({ length: 3 }).map((_, i) => (
            <Box key={i}>
              <HStack justify="space-between" mb={1}>
                <Skeleton height="14px" width="80px" />
                <Skeleton height="14px" width="60px" />
              </HStack>
              <Skeleton height="8px" width="100%" borderRadius="full" />
            </Box>
          ))}
        </VStack>
      </Box>
    </HStack>
  )
}
